import axiosInstant from "../axiosInstant";

export async function registerNotificationToken(token) {
  try {

    const res = await axiosInstant.post(
      "notification/register-token",
      {
        token: token,
        platform: "web",
        browser: "chrome"
      }
    );

    return res.data;

  } catch (error) {

    console.error(
      "Register notification token error:",
      error
    );

    return undefined;
  }
}